import { WalletAdSkeleton, WalletAdEntry } from '../models/WalletAd';
import { contentfulApi } from 'common/api/utils/contentful';
import { loadFromContentful } from '../utils';
import { IS_FLIPGIVE } from 'common/env';
import { PlatformContentType } from '../models/PlatformContentType';

export const getWalletAdsList = async () => {
    const response = await loadFromContentful('walletAdList', {
        'fields.title[in]': IS_FLIPGIVE
            ? PlatformContentType.FlipGive
            : PlatformContentType.RaiseRight,
    });

    if (response.data?.items?.length) {
        const walletAds = response.data.items[0]?.fields?.walletAds || [];
        return walletAds;
    }

    return [];
};

export const getWalletAds = async (): Promise<WalletAdEntry[]> => {
    const entries = await contentfulApi.getEntries<WalletAdSkeleton, unknown>({
        content_type: 'walletAd', // eslint-disable-line camelcase
    });

    if (!entries.data || !entries.data.items.length) {
        return [];
    }

    return entries.data.items;
};
